
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
name: 'checkChoice',
props: {
choice: {},
cuIndex: 0
},
components: {
Checker, Group, Cell, CheckerItem
},
data () {
return {
options: [],
anwser: '',
haOptions: ''
}
},
created () {
this.setOptions(this.choice)
},
watch: {
choice: function () {
this.setOptions(this.choice)
}
},
methods: {
getAnswer () {
return this.choice
},
setOptions: function (choice) {
this.options = []
const {options} = choice.choices
const {userAnswer} = choice
this.options = options
if (userAnswer) {
this.anwser = userAnswer
}
},
toggleOption (value) {
this.choice.userAnswer = value

if (value.length > 0 && this.haOptions.length === 0) {



}
}
}
}



// WEBPACK FOOTER //
// ./src/components/Subjects/CheckChoice/index.vue